import { useMemo } from 'react';
import { useGameStore } from '../../stores';

//TODO: move this hook to hooks folder
export const useGeneralMode = () => {
  const { generalModeData } = useGameStore();

  const latitude = useMemo(
    () => Number(generalModeData?.location?.latitude),
    [generalModeData?.location?.latitude],
  );

  const longitude = useMemo(
    () => Number(generalModeData?.location?.longitude),
    [generalModeData?.location?.longitude],
  );

  const deadline = useGameStore(
    (state) => state.generalModeData?.location?.endTimeStamp,
  );

  const attempts = useGameStore((state) => state.generalModeData?.attempts);

  const score = useGameStore((state) => state.generalModeResult?.score);

  const disableTries = useMemo(() => attempts === 0, [attempts]);

  const totalAttempts = useGameStore(
    (state) => state.generalModeStatus?.totalAttempts,
  );
  return {
    latitude,
    longitude,
    attempts,
    score,
    disableTries,
    deadline,
    totalAttempts,
  };
};
